export default "__VITE_ASSET__Dd4wh9sj__"